import { Primitive, styled } from '@miro-site/ui-styled-engine';
/**
 * Create a styled wrapper to support stitches features and props
 */

var SectionStyled = styled(Primitive.div);
export default SectionStyled;